import type { SVGProps } from "react"

/**
 * TikTok logomark SVG — black-bg variant per the TikTok developer brand
 * kit at `developers.tiktok.com/doc/login-kit-web`. Used inside the
 * CTPO-locked TikTok-style Connect button (`<TiktokConnectCta>`).
 *
 * The white-fill path is paired with the parent's `#000000` background
 * — never re-style this glyph. Replacing the SVG requires a CTPO call
 * (per OKS-23 UX Spec §2 Asset source row).
 *
 * Default size 24×24 matches the spec; consumers can override via
 * `width` / `height` props (e.g. the inline 20×20 used inside the
 * Connect button).
 */
export function TiktokIcon({
  width = 24,
  height = 24,
  fill = "#fff",
  "aria-hidden": ariaHidden = "true",
  ...rest
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...rest}
    >
      <path
        fill={typeof fill === "string" ? fill : "#fff"}
        d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
      />
    </svg>
  )
}

export default TiktokIcon
